import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Form } from 'formsy-react' //eslint-disable-line
import { isEmpty, isNil } from 'ramda'
import {
  Colors,
  Select,
  Button,
} from 'advenio-components'
import { toPlainObject, userHasRole } from '../../../utils/Utils'
import EvaluationActions from '../../../Data/Redux/EvaluationRedux'
import LoadingSpinner from '../../LoadingSpinner'
import EvaluationDimention from './EvaluationDimention'
import { BACK_OFFICE_CENTER_ROLES, BACK_OFFICE_ROLES } from '../../../Constants'

const TableHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 100%;
  background-color: ${Colors.gray300};
  color: white;
`
const EmptyState = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  opacity: .4;
`
const FormEvaluationContainer = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 16px;
  @media (max-width:767px) {
    display: none;
  }
`
const ContainerEvaluation = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  margin-top: 12px;
`
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  margin: 16px 0;
  gap: 32px;

  > * {
    flex: 0 0 auto;
  }
  @media (max-width:1024px) {
    display: inline-grid;
    gap: 16px;
  }
`
const DivScore = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  background-color: white;
  border-radius: 8px;
  padding: 12px 16px;
`
const DivScoreLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`
const   DivIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  font-weight: bold;
  font-size: 16px;
  background-color: ${({ color }) => color || '#4A90E2'};
`
const DivScoreValue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 14px;
`
const LastUpdateText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 16px;
  color: #6B46C1;
  font-size: 14px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 16px;
  margin-left: -35px  ;
`
const CreateButton = styled(Button)`
  padding: 12px 32px;
  font-weight: bold;
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 16px;
  margin-left: -35px  ;
`
const initialState = {
  program: null,
  dimentions: [],
  evaluation: {},
  dimention: {},
  formData: {},
  countCycles: 0,
  observation: '',
  showCycles: false,
  cycleSelected: 0,
  programId: null,
}
class Evaluation extends Component {
  state = initialState

  componentWillMount() {
    const { getDimentionCat, getResultsCat, getCyclesCat, getStudyProgramsCat } = this.props
    getDimentionCat()
    getResultsCat()
    getCyclesCat()
    getStudyProgramsCat()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    console.log(`⛔ - componentWillMount`, this.props.student)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
    this.setState({...initialState})
    this.props.resetEvaluation()
  }
  handleResize = () => {
    this.setState({ showCycles: window.innerWidth <1024 ? true : false })
  }

  /*componentWillReceiveProps(nextProps) {
    console.log(`⛔ - nextProps.evaluation`,nextProps.evaluation, this.props.evaluation)
    if(!isNil(nextProps.evaluation.id)){
      this.setState({ evaluation: nextProps.evaluation, dimentions: nextProps.evaluation.details, comments: nextProps.evaluation.comments })
    }
  }*/
  componentWillReceiveProps(nextProps){
    let dimentions = []
    let evaluation = {}
    let dimention = {}
    let observation = ''
    if(nextProps.evaluation !== this.props.evaluation && !isEmpty(nextProps.evaluation)){
      evaluation = nextProps.evaluation
      dimentions = nextProps.evaluation.details
      if(!isEmpty(this.state.dimention)){
        dimention = this.state.dimention
        const obsObj = nextProps.evaluation.observations.find(d => Number(d.dimention.id) === Number(this.state.dimention.id));
        dimention.observation = obsObj ? obsObj.observation : '';
        observation = obsObj ? obsObj.observation : '';
      }
    }
    this.setState({evaluation, dimentions, dimention, observation})
  }

  userHasRole = roles => userHasRole(this.props.user.role, roles)

  handleProgramChange = (value) => {
    const { studyPrograms = [], getDimentionByStudyProgram, student = {} } = this.props;
    const studyProgram = studyPrograms.find(function(sp) { return String(sp.id) === String(value); });
    const programId = (studyProgram && studyProgram.id) ? studyProgram.id : null;

    this.setState((prevState) => (
      { ...prevState, ...initialState, programId }
    ), () => {
      if (!isNil(programId) && !isEmpty(programId)) {
        getDimentionByStudyProgram(student.id, programId)
      }
    });
  }

  handleDimentionChange = (value) => {
    this.setState({dimention: {}, showCycles: false, cycleSelected: 0, formData: {}, countCycles: 0, observation: ''})
    if(isNil(value) || isEmpty(value) || value === ' '){
      /*console.log(`⛔ - Handle Dimention Change`,value)
      this.setState({ dimention: {}, showCycles: false, cycleSelected: 0 , formData: {}, countCycles: 0, observation: ''})*/
      return
    }
    const { dimentions, evaluation } = this.state
    let dimention = dimentions.find(d => Number(d.id) === Number(value))
    dimention = {
      ...dimention,
      // Si no existe la observación, usar ''
      observation: (() => {
        const foundObservation = evaluation.observations.find(d => Number(d.dimention.id) == Number(value));
        return foundObservation ? foundObservation.observation : '';
      })()
    }
    this.handleResize()
    this.initializeFormData(dimention)
    this.setState({ dimention })
  }

  handleCycleChange = (value) => {
    if(isNil(value) || isEmpty(value) || value === ' '){
      this.setState({cycleSelected: 0, dimention: {}, formData: {}, countCycles: 0, observation: ''})
      return
    }
    this.setState({ cycleSelected: value })
  }

  initializeFormData = (dimention) => {
    if (isEmpty(dimention) || isNil(dimention.section)) {
      return
    }

    const formData = {}
    let counterCycles = 0;
    dimention.section.forEach(section =>
      section.questions.forEach(question => {
        if (counterCycles < question.answers.length) {
          counterCycles = question.answers.length;
        }
        question.answers.forEach(answer => {
          formData[answer.id] = (answer.result && answer.result.id) ? answer.result.id : null;
        });
      })
    );

    this.setState({ formData, countCycles: counterCycles || 0, observation: dimention.observation || '' })
  }


  handleSave = (saveData) => {
    let payload = {
      evaluationId: this.props.evaluation.id,
      studentId: this.props.student.id,
      body: {
        ...saveData,
        student_id: this.props.student.id,
        evaluation_id: this.props.evaluation.id,
        dimention_id: saveData.dimentionId,
      },
    }
    const { saveEvaluation } = this.props
    saveEvaluation(payload)
  }

  handleCreateEvaluation = () => {
    const { createEvaluation } = this.props
    const payload = {
      studentId: this.props.student.id,
      studyProgramId: this.state.programId,
    }
    createEvaluation(payload)
  }
  
  handleDeleteEvaluation = () => {
    const { deleteEvaluation } = this.props
    const payload = {
      studentId: this.props.student.id,
      evaluationId: this.props.evaluation.id,
    }
    deleteEvaluation(payload)
  }
  
  handleGeneratePdf = ()=>{
    const{ student:{id:studentId}, evaluation:{id:evaluationId}, generatePDF} = this.props
    generatePDF({studentId, evaluationId})
  }

  handleShowPDF = () => {
    const { evaluation } = this.props
    window.open(evaluation.pdf_path, '_blank')
  }

  getFormatLabel = (index, programId) =>{
    let label = `${programId < 4 ? 'Mes':'Ciclo'} ${index + 1}`
    if(programId === 2){
      label = `Mes ${index + 7}`
    }
    if(programId === 3){
      label = `Mes ${index + 13}`
    }
    return label
  }
  renderOptions = (data) => data.map(option =>({ id: option.id, label: option.translation || option.name, value:option.id }))

  renderOptionsCycles = (countCycles, programId) => Array.from({ length: countCycles }, (_, index) => ({ id: index + 1, label:this.getFormatLabel(index,programId), value: index + 1 }))

  renderDimention = () => {
    const { cyclesResults, cycles, student } = this.props
    const currentProgram = this.props.programsCenter.find(program => program.id === student.study_program_id).study_program_id
    console.log(`⛔ - currentProgram`,currentProgram)
    const { dimention, formData, countCycles, observation, cycleSelected, showCycles, programId } = this.state
    if((isEmpty(dimention) && !showCycles) || (showCycles && cycleSelected === 0)){
      return null
    }

    return (
      <EvaluationDimention
        dimention={dimention}
        cyclesResults={cyclesResults}
        cycles={cycles}
        formData={formData}
        countCycles={countCycles}
        observation={observation}
        cycleSelected={cycleSelected}
        showCycles={showCycles}
        onSave={this.handleSave}
        programId={programId}
        currentProgram={currentProgram}
      />
    )
  }

  render() {
    const {
      anyLoading,
      dimentionsCat,
      studyPrograms,
      user,
      loadingEvaluation
    } = this.props
    const {
      dimentions,
      showCycles,
      countCycles,
      cycleSelected,
      programId,
      evaluation,
    } = this.state

    return (
      (! anyLoading ?
      <ContainerEvaluation>
        {!this.userHasRole(['Parent', 'Teacher']) && (
            <FormEvaluationContainer>
              <Form
              style={{width: '100%'}}
              >
                <Container >
                  <Select
                    name="program"
                    label="Programas"
                    required
                    value={null}
                    onChangeCallback={({target:{value}}) => this.handleProgramChange(value)}
                    emptyElement
                    options={this.renderOptions(studyPrograms)}
                  //  disabled={ userHasRole(user,['Back Office Admin']) ? false : (teacher || Boolean(isDisenrolled)|| student.checkin.id !== null)}
                  />
                  {!isEmpty(dimentions) && (
                  <Select
                    name="dimentions"
                    label="Dimensiones"
                    required
                    value={null}
                    onChangeCallback={({target:{value}}) => this.handleDimentionChange(value)}
                    emptyElement
                    options={this.renderOptions(dimentions)}
                    //disabled={ userHasRole(user,['Back Office Admin']) ? false : (teacher || Boolean(isDisenrolled)|| student.checkin.id !== null)}
                  />)}
                  {showCycles && countCycles > 0 && (
                    <Select
                      name="cycles"
                      label={programId < 4 ? "Mes" : "Ciclo"}
                      required
                      value={cycleSelected}
                      onChangeCallback={({target:{value}}) => this.handleCycleChange(value)}
                      emptyElement
                      options={this.renderOptionsCycles(countCycles, programId)}
                      //disabled={ userHasRole(user,['Back Office Admin']) ? false : (teacher || Boolean(isDisenrolled)|| student.checkin.id !== null)}
                    />
                  )}
                  <DivScore>
                    <DivScoreLabel>
                      <DivIcon color="#B9E8F3">
                        <span style={{ color: '#4AC1E0' }}>I</span>
                      </DivIcon>
                      <DivScoreValue>
                        Inició
                      </DivScoreValue>
                    </DivScoreLabel>
                    <DivScoreLabel>
                      <DivIcon color="#FFF1AD">
                        <span style={{ color: '#8F7700' }}>P</span>
                      </DivIcon>
                      <DivScoreValue>
                        En Progreso
                      </DivScoreValue>
                    </DivScoreLabel>
                    <DivScoreLabel>
                      <DivIcon color="#F3DFF7">
                        <span style={{ color: '#BB4DD1' }}>L</span>
                      </DivIcon>
                      <DivScoreValue>
                        Logrado
                      </DivScoreValue>
                    </DivScoreLabel>
                  </DivScore>
                </Container>
                {!isEmpty(evaluation) && (
                <LastUpdateText>
                  Última actualización, { moment(evaluation.updated_at).format('DD [de] MMMM, YYYY [a las] HH:mm:ss')}
                </LastUpdateText>
                )}
                <ButtonsContainer>
                {!isNil(programId) && !loadingEvaluation && isEmpty(evaluation) && (
                    <CreateButton key="create-evaluation" success onClick={this.handleCreateEvaluation}>
                      Crear Evaluación
                    </CreateButton>
                )}
                {!isEmpty(evaluation) && !isNil(evaluation.pdf_path) && (
                    <Button key="download-pdf" primary onClick={this.handleShowPDF}>Ver evaluación</Button>
                )}
                {!isEmpty(evaluation) && userHasRole(user,BACK_OFFICE_CENTER_ROLES) && (
                    <Button key="generate-pdf" success onClick={this.handleGeneratePdf}>
                      Generar PDF
                    </Button>
                )}
                {!isEmpty(evaluation) && userHasRole(user,BACK_OFFICE_CENTER_ROLES) && (
                    <Button key="delete-evaluation" danger onClick={this.handleDeleteEvaluation}>
                      Eliminar Evaluación
                    </Button>
                )}
                </ButtonsContainer>
              </Form>
            </FormEvaluationContainer>
        )}
        { loadingEvaluation && (<LoadingSpinner containerHeight={300} />)}
        {this.renderDimention()}
      </ContainerEvaluation>
      : <LoadingSpinner size={50} />)
    )
  }
}

Evaluation.propTypes = {
  student: PropTypes.object.isRequired,
}

Evaluation.defaultProps = {
  isDisenrolled: false,
  parent: false,
  anyLoading: true,
  dimentionsCat: [],
  evaluation: {},
  cyclesResults: [],
  cycles: [],
}

const mapStateToProps = state => {
  const evaluation = state.evaluation.evaluation.result
  // Convertir evaluation y todos sus objetos anidados
  const plainEvaluation = toPlainObject(evaluation)
  return {
    dimentionsCat: toPlainObject(state.evaluation.dimention.results),
    anyLoading: state.evaluation.dimention.fetching ||
      state.evaluation.cyclesResults.fetching ||
      state.evaluation.cycles.fetching ||
      state.evaluation.studyPrograms.fetching,
    loadingEvaluation:state.evaluation.evaluation.fetching,
    user: state.auth.user,
    studyPrograms: toPlainObject(state.evaluation.studyPrograms.results),
    evaluation: plainEvaluation,
    cyclesResults: toPlainObject(state.evaluation.cyclesResults.results),
    cycles: toPlainObject(state.evaluation.cycles.results),
    programsCenter: state.study_programs.get.results,
  }
}

const mapDispatchToProps = dispatch => ({
  getDimentionCat: () =>
    dispatch(EvaluationActions.getDimentionCatalogueRequest()),
  getResultsCat: () =>
    dispatch(EvaluationActions.getResultsCatalogueRequest()),
  getCyclesCat: () =>
    dispatch(EvaluationActions.getCyclesCatalogueRequest()),
  getStudyProgramsCat: () =>
    dispatch(EvaluationActions.getStudyProgramsCatalogueRequest()),
  getDimentionByStudyProgram: (studentId,studyProgramId) =>
    dispatch(EvaluationActions.getDimentionByStudyProgramRequest({studentId,studyProgramId})),
  saveEvaluation: (payload) =>
    dispatch(EvaluationActions.patchEvaluationRequest(payload)),
  createEvaluation: (payload) =>
    dispatch(EvaluationActions.createEvaluationRequest(payload)),
  deleteEvaluation: (payload) =>
    dispatch(EvaluationActions.deleteEvaluationRequest(payload)),
  generatePDF: (payload) =>
    dispatch(EvaluationActions.generatePDFRequest(payload)),
  resetEvaluation: () =>
    dispatch(EvaluationActions.resetEvaluation()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Evaluation)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Evaluation/Evaluation.jsx